import * as firebase from "firebase/app";
import {getMessaging} from "firebase/messaging";
import {IS_DEV, FCM_CONFIG} from "../../../common/constant";

const firebaseConfig = window.location.hostname.includes('superworks.com') ? {
    apiKey: "AIzaSyAPrQDXp-eg1yljhCTjYnyddQibMjwiDcQ",
    authDomain: "recruit-live.firebaseapp.com",
    databaseURL: "https://recruit-live-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "recruit-live",
    storageBucket: "recruit-live.appspot.com",
    messagingSenderId: "500452471377",
    appId: "1:500452471377:web:fb0b5798a98f3c7ef2fe70",
    measurementId: "G-PCMMFPXML1"
} : {
    apiKey: "AIzaSyBrnjfIfELNdDj8edxFBX1ryhYp1UuYvm0",
    authDomain: "recruit-staging-4b380.firebaseapp.com",
    databaseURL: "https://recruit-staging-4b380-default-rtdb.firebaseio.com",
    projectId: "recruit-staging-4b380",
    storageBucket: "recruit-staging-4b380.appspot.com",
    messagingSenderId: "412862354657",
    appId: "1:412862354657:web:c2a1c269ad26f256fed3a0",
    measurementId: "G-44R7SYEEQF"
}
FCM_CONFIG && firebase.initializeApp(firebaseConfig);

let messaging = IS_DEV ? {} : FCM_CONFIG ? getMessaging() : {};

export {messaging, firebaseConfig};
